import { AxiosInstance } from 'axios'

import { Money } from '@percent/utility'

export type donationRequestsServiceCapabilities = {
  percentClient: AxiosInstance
}

export enum DonationRequestStatus {
  pending = 'pending',
  cancelled = 'cancelled',
  settled = 'settled'
}

export type DonationRequest = {
  id: string
  status: DonationRequestStatus
  foundationId: string
  partnerId: string
  subsidiaryId?: string
  start: Date
  end: Date
  amount: number
  currency: string
  createdAt: Date
  cancelledAt?: Date
  settledAt?: Date
  createdBy?: string
  cancelledBy?: string
  settledBy?: string
  reference: string
}

export const ALL_DONATION_KINDS = ['direct', 'wallet', 'matched', 'payroll'] as const

export type DonationRequestDonationKind = typeof ALL_DONATION_KINDS[number]

export const ALL_DONATION_CATEGORIES = [
  'grant',
  'corporate_donation',
  'consumer_giving',
  'employee_impact',
  'unclassified'
] as const

export type DonationRequestDonationCategory = typeof ALL_DONATION_CATEGORIES[number]

export type DonationRequestAmount = {
  kind: DonationRequestDonationKind
  amount: Money
}

export type DonationRequestEnhanced = DonationRequest & {
  partnerName: string
  amounts?: DonationRequestAmount[]
  subsidiaryName?: string
}

export type GetDonationRequestProps = {
  id: string
}

export type GetDonationRequestListProps = {
  pageSize?: number
  cursor?: string
  status?: DonationRequestStatus
  partnerId?: string
}

export type GetIndividualDonationsEnhancedListProps = {
  page?: number
  pageSize?: number
  cursor?: string
}

export type GetDonationsPerNonprofitEnhancedListProps = {
  page?: number
  pageSize?: number
  cursor?: string
}

export type CreateDonationRequestsBatchProps = {
  partnerId: string
  startDate: string
  endDate: string
  preferredFoundationId?: string
  importBatchId?: string
  donationKinds?: DonationRequestDonationKind[]
  category?: DonationRequestDonationCategory[]
}

export type CancelDonationRequestProps = {
  id: string
}

export type SettleDonationRequestProps = {
  id: string
  settledAt: Date
}

export type DonationPerNonprofitInfo = {
  amount: number
  currency: string
  organisationId: string
}

export type DonationPerNonprofitEnhancedInfo = DonationPerNonprofitInfo & {
  organisationName: string
}

export type IndividualDonationInfo = {
  id: string
  organisationId: string
  amount: number
  currencyCode: string
  createdAt: string
}

export type IndividualDonationEnhancedInfo = IndividualDonationInfo & {
  organisationName: string
}
